import { LeadManagementAction } from './enum';
import { LeadManagementForm, LeadManagementResponse } from './interface';

export const submitLeadManagementForm = () => ({
    type: LeadManagementAction.SUBMIT as const,
});

export const setLeadManagementResult = (result: LeadManagementResponse) => ({
    type: LeadManagementAction.SET_RESULT as const,
    result,
});

export const setForm = (form: Partial<LeadManagementForm>) => ({
    type: LeadManagementAction.SET_FORM as const,
    form,
});

export const setLeadManagementError = (error: Error) => ({
    type: LeadManagementAction.SET_ERROR as const,
    error,
});

export type Actions = ReturnType<typeof submitLeadManagementForm>
    | ReturnType<typeof setLeadManagementResult>
    | ReturnType<typeof setForm>
    | ReturnType<typeof setLeadManagementError>;
